import React, { useMemo,useEffect,useState } from "react";
import withRouter from "../../../components/Common/withRouter";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import { corporateCustomer } from "../../../common/data/MyFackData";
import { Link } from "react-router-dom";

const Corporate = () => {

  const baseurl = process.env.REACT_APP_BASE_URL;
    const imgurl = process.env.REACT_APP_IMAGE_URL;
  
    const [corporateCustomer, setcorporateCustomer] = useState([]);
    const [error, setError] = useState(null);

    const fetchcorporateCustomer = async () => {
                try {
                  setError(null);
                  const response = await fetch(`${baseurl}/admin/customer/corporates`);
                  if (!response.ok) throw new Error("Network response was not ok");
                  const data = await response.json();
                  setcorporateCustomer(data);
                } catch (error) {
                  setError(error.message);
                }
              };
    
              useEffect(() => {
                          fetchcorporateCustomer();
                        }, []);
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Company Name",
        accessor: "company_name",
        filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
{
        Header: "GST Number",
        accessor: "gst_number",
        filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Discount %",
        accessor: "discount",
        filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">{value} %</div>,
      },
      {
        Header: "Total Purchase",
        accessor: "balance",
        filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">₹ {value}</div>,
      },

      {
        Header: "Status",
        accessor: "status",
        filterable: true,
        Cell: ({ value }) => {
          return (
            <Badge color={value === "Active" ? "success" : "danger"}>
              {value.charAt(0).toUpperCase() + value.slice(1)}
            </Badge>
          );
        },
      },
      {
        Header: "Diligence",
        accessor: "Diligence",
        filterable: true,
        Cell: ({ value }) => (
          <div className="text-body fw-bold">Modified Diligence</div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link
                  to={`/manage-customers/corporate/customer-details/${row.original.id}`}
                  className="text-success"
                >
                  <i
                    className="mdi mdi-eye-outline font-size-18"
                    id="viewtooltip"
                  ></i>
                </Link>
              </li>
              <UncontrolledTooltip placement="top" target="viewtooltip">
                View
              </UncontrolledTooltip>
            </ul>
          );
        },
      },
    ],
    []
  );

  document.title = "Corporate Customer | Vekart";

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Manage Customers" breadcrumbItem="Corporate" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={corporateCustomer}
                    isGlobalFilter={true}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default withRouter(Corporate);
